import BaseService from './BaseService'
import { cacheManager } from '../utils/CacheManager'

class ConversationChannelService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  fetchCustomConversationChannels = (locationId: string) => {
    const query = `?locationId=${locationId}&type=custom`
    return cacheManager.getCachedData(`custom-conversation-channels`, () => this.requests.get('/providers/search' + query), {
      key: `custom-conversation-channels-${locationId}`
    })
  }

  fetchDefaultConversationChannels = (locationId: string) => {
    const query = `?locationId=${locationId}&type=defaults`
    return cacheManager.getCachedData(`default-conversation-channels`, () => this.requests.get('/providers/search' + query), {
      key: `default-conversation-channels-${locationId}`
    })
  }

}

const instance = new ConversationChannelService(BaseService.servicesConfig.Conversations)

export default instance
